module.exports = __webpack_public_path__ + "img/41.047b9b71.jpg";